import api from './api'
import store from '@/store'
import authHeader from '@/services/auth-header';
import CallHelper from '@/helpers/call.helper'

class PersonService {
    async get(params = {}) {
        return CallHelper.getDataRecursive(
            '/person-group/' + params.person_group_uuid + '/person',
            params,
            (data, response) => {

                if(data['persons']) {
                    data['persons'] = [...data['persons'], ...response.data.persons]
                } else {
                    data['persons'] = response.data.persons
                }

                return data
            },
        )
    }

    async search(personGroupUuid, params = {}) {
        return api.get('/person-group/' + personGroupUuid + '/person/search', {'params': params}, authHeader()).then(response => response.data);
    }

    async searchByAccount(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/person/search', {'params': params}, authHeader()).then(response => response.data);
    }

    async create(person, personGroupUuid) {
        return api.post('/person-group/' + personGroupUuid + '/person', {
            name: person.name,
            email: person.email,
            phone: person.phone,
            note: person.note,
        })
        .then(response => response.data);
    }

    async createByAccount(person) {
        return api.post('/account/' + store.state.account.uuid + '/person', {
            name: person.name,
            email: person.email,
            phone: person.phone,
            note: person.note,
        })
        .then(response => response.data);
    }

    async modify(person, personGroupUuid) {
        return api.patch('/person-group/' + personGroupUuid + '/person/' + person.uuid, {
            name: person.name,
            email: person.email,
            phone: person.phone,
            note: person.note,
        })
        .then(response => response.data);
    }

    async modifyByAccount(person) {
        return api.patch('/account/' + store.state.account.uuid + '/person/' + person.uuid, {
            name: person.name,
            email: person.email,
            phone: person.phone,
            note: person.note,
        })
        .then(response => response.data);
    }

    async delete(personUuid, personGroupUuid) {
        return api.delete('/person-group/' + personGroupUuid + '/person/' + personUuid).then(response => response.data);
    }

    async deleteByAccount(personUuid) {
        return api.delete('/account/' + store.state.account.uuid + '/person/' + personUuid).then(response => response.data);
    }
}

export default new PersonService();
